import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
// import toplist_en from './locales/en-US/toplist.json'
// import chartlist_en from './locales/en-US/chartlist.json'
// import categorytags_en from './locales/en-US/categorytags.json'
// import category_en from './locales/en-US/category.json'

// don't want to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init
i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use( Backend )
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use( LanguageDetector )
  // pass the i18n instance to react-i18next.
  .use( initReactI18next )
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init( {
    preload: ['en-US', 'en'],
    lng: "en-US",
    fallbackLng: 'en-US',
    debug: true,
    //locale: 'zh-CN',
    load: 'all',
    resources: {
      'topCharts': require( './locales/en-US/chartsToplist.json' ),
      'toplist': require( './locales/en-US/toplist.json' ),
      'chartlist': require( './locales/en-US/chartlist.json' ),
      'categorytags': require( './locales/en-US/categorytags.json' ),
      'category': require( './locales/en-US/category.json' ),
      'hotCat': require( './locales/en-US/hotcategories.json' ),
      'album': require( './locales/en-US/album.json' ),
    },
    ns: ["toplist", "chartlist", "categorytags", "category"],
    defaultNS: "topCharts",
    excludeCacheFor: ['cimode'],
    detect: {
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
    },
    lookupFromPathIndex: 0,
    lookupFromSubdomainIndex: 0,
    htmlTag: document.documentElement,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      wait: true
    },
    backend: {
      loadPath: 'public/locales/{{lng}}/{{ns}}.json',
      // jsonIndent: 2,
    }
  } )

export default i18n
// console.log( i18n?.options, "i18next--toplevel" )